export const SetAccessoryPacksText = packs => {
  return packs.map(SetAccessoryPackText);
};

export const SetAccessoryPackText = pack => {
  const text = `Fitted RRP: ${pack.rrp}`;
  let textFull = `<p>${text}</p>`;
  textFull += `<p>&nbsp</p>`;
  textFull += `<p>${pack.title} includes:</p>`;
  textFull += `<ul>`;
  pack.slides.forEach(slide => {
    textFull += `<li>${slide.title}</li>`;
  });
  textFull += `</ul>`;
  textFull += `<p class="highlight__disclaimer">Price is Subaru Australia’s Special Fitted Recommended Price. Actual price may vary between retailers. Ask your retailer for their final price. Fitted RRP is the Recommended Retail Price. The Fitted RRP includes the price of the accessory item (excluding government stamp duty), installation (if necessary) and painting (if necessary). Government stamp duty charges will appear in the Driveaway price of the vehicle after they have been added to the vehicle.</p>`;
  return { ...pack, textFull, text };
};
